<button
  mat-flat-button
  class="empathy-viewer-button"
  [matTooltip]="text ?? tooltip"
  [title]="text ?? tooltip"
  [color]="color"
  [disabled]="disabled || loading"
  [ngClass]="background"
  (click)="clicked.emit()"
>
  @if (loading) {
    <ng-container *ngTemplateOutlet="loadingContainer"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="textContainer"></ng-container>
  }
</button>

<ng-template #loadingContainer>
  <div class="empathy-viewer-button__loading">
    <mat-spinner diameter="20" color="light"></mat-spinner>

    <span class="fs__lg fw__500">{{ loadingText }}</span>
  </div>
</ng-template>

<ng-template #textContainer>
  <div class="empathy-viewer-button__text-icon" [ngClass]="iconPosition">
    @if (icon) {
      <fa-icon [icon]="icon" size="lg"></fa-icon>
    }

    @if (text) {
      <span class="fs__lg fw__500">{{ text }}</span>
    }
  </div>
</ng-template>
